const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/members/manage.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/members/manage")({
  beforeLoad: () => {
    redirect({
      to: "/settings/audience/manage",
      replace: true,
      search: true,
      state: true,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});